<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.host')}}/Port:</label>
            <div class="col-6">
                <input type="text" v-model="value.Host" name="Host" class="form-control"  maxlength="300" required/>
            </div>
            <div class="col-3">
                <input type="number" v-model="value.Port" name="Port"  class="form-control"  min="1" max="65536" required />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.username')}}</label>
            <div class="col">
                <input v-model="value.Username" name="UserName" type="text" class="form-control"   @change="$forceUpdate()" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.passcode')}}</label>
            <div class="col">
                <password v-model="value.Password" name="Password" class="form-control"  @change="$forceUpdate()" />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.fingerprint')}}</label>
            <div class="col">
                <input v-model="value.FingerPrint" name="FingerPrint" type="text" class="form-control"  />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.uzakDizin')}}</label>
            <div class="col">
                <div class="input-group mb-3">
                    <input v-model="value.Path" name="Path" type="text" class="form-control"  />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary" @click="$emit('ftpLookupTargetSystem')">
                            {{translate('lookup')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.EnableSSL" />
                    {{translate('incomingDoc.sslEnabled')}}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import password from '@/components/Password.vue'
import axios from 'axios';


export default {
    components: {
        password
    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {
        ftpLookupTargetSystem(customPath) {
            if (!this.validTargetSystem() || this.loading)
                return;

            this.loading = true;

            var formData = Object.assign({}, this.data);

            if (customPath)
                formData.Path = customPath;

            axios
                .post("/TargetSystem/FtpLookup", formData)
                .then((x) => {
                    if (x.data.Success) {
                        this.lookupResult = { TargetSystem: x.data.TargetSystem, Files: x.data.Files };
                    } else {
                        alert(this.translate('incomingDoc.lookupFailed') + x.data.Exception);
                    }
                    this.$forceUpdate();
                })
                .catch((x) => {
                    alert(this.translate('incomingDoc.lookupFailed') + x);
                })
                .then(() => {
                    this.loading = false;
                });
        },

    }
}

</script>
